import { GET_ALL_TOKENS } from './mutation-types'
import tokenHttpService from '../_services/tokenHttpServices'

export default {
  listAllTokens: async ({ commit }) => {
    try {
      const response = await tokenHttpService.getAllTokens()
      commit(GET_ALL_TOKENS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
